import { makeAutoObservable } from "mobx";
const USER_ID_STORE_KEY = "userId";
export class UserIdStore {
    userId = "";
    constructor() {
        makeAutoObservable(this, {
            setUserId: true // action
        });
        const storedUserId = localStorage.getItem(USER_ID_STORE_KEY);
        if (storedUserId) {
            this.userId = storedUserId;
        }
    }
    setUserId(userId) {
        this.userId = userId;
        localStorage.setItem(USER_ID_STORE_KEY, userId);
    }
}
